
  

  const odemeSekliOptions = [

    {
      value:  "Peşin",
      text: "Peşin",
    },
    {
      value:  "Karşı Ödemeli",
      text: "Karşı Ödemeli",
    },
    {
      value:  "Havale",
      text: "Havale",
    },
    {
      value:  "Havale(7gün)",
      text: "Havale(7gün)",
    },
    {
      value: "Havale(14gün)",
      text: "Havale(14gün)",
    },
    {
      value:  "Nakit + Yakıt",
      text: "Nakit + Yakıt",
    },
    {
      value:  "Yakıt",
      text: "Yakıt",
    },
    {
      value:  "Diğer",
      text: "Diğer",
    }
  ]



  export { odemeSekliOptions }